import useController from '@common/hooks/useController'

// Native shim — read state from in-process ControllerStore.
// Web variant relies on `AddressBookControllerStateProvider` not mounted on RN.
export default function useAddressBookControllerState(): any {
  const { state } = useController('AddressBookController' as any)
  return state as any
}
